
export enum BannerAdminDataV1Action {
    "GO_TO_DEEPLINK" = "GO_TO_DEEPLINK",
    "GO_TO_URL" = "GO_TO_URL"
}
export enum BannerAdminDataV1Deeplink {
    "STATUS_REQUEST" = "STATUS_REQUEST",
    "PROFILE" = "PROFILE",
    "SEND_REQUEST" = "SEND_REQUEST",
    "AUTH" = "AUTH",
    "BLOG" = "BLOG"
}
export enum BannerAdminDataV1Status {
    "ACTIVE" = "ACTIVE",
    "INACTIVE" = "INACTIVE",
    "DELETED" = "DELETED"
}
export type BannerAdminDataV1 = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    title: string;
    /**
     * @type string
    */
    action: BannerAdminDataV1Action;
    /**
     * @type string | undefined
    */
    deeplink?: BannerAdminDataV1Deeplink;
    /**
     * @type string | undefined
    */
    url?: string;
    /**
     * @type string
    */
    status: BannerAdminDataV1Status;
    /**
     * @type string
    */
    imgUrl: string;
};
